import { cloneDeep } from 'lodash-es'
import { modelList } from '@views/main/config/index.js'
// import data from '../test.json'

const colors = [
  '#4080FF',
  '#FC9EC6',
  '#F979B7',
  '#8AE6E0',
  '#21D2D1',
  'C296ED',
  '#A871E3',
  '#7BE189',
]

function parseFraction(str: string): number {
  const parts = str.split('/')
  if (parts.length !== 2) return NaN // 非分数格式返回NaN

  const numerator = Number(parts[0])
  const denominator = Number(parts[1])

  // 防止除以0的情况
  if (denominator === 0) return 0

  return Math.round((numerator * 100) / denominator) || 0
}

export default (data: any) => {
  // const { citationSummary, enhancedReport } = data.result
  const { enhancedReport } = data
  const brandVisibility = [] // 品牌知名度
  const brandImageTags = [] // 词云数据来源
  let geoDiagnosis = '' // geo专业建议
  let coverageArr = [] // 提及率
  let completionArr = [] // 完成度
  let mentioningRateArr = [] // 首选被提及率
  let dataOverview = [] // 数据概览
  let keywordRate = [] // AI回复内容类型占比
  const modelCitationDetail = [] // 模型引用详情
  const brandAwareness = [] // 品牌认知
  let informationCompletenessSource = [] // 信息完整性来源

  let totalCitationCount = 0
  const copyModelList = cloneDeep(modelList.value)
  const copyColors = cloneDeep(colors)
  copyModelList.forEach(x => {
    if (data[x.value] !== undefined) {
      totalCitationCount += data[x.value] || 0
      modelCitationDetail.push({
        name: x.label,
        value: data[x.value] || 0,
        color: copyColors.shift(),
      })
    }
  })
  let effectiveCitationCount = 0
  // 总引用为0时，有效引用也为0
  if (totalCitationCount) {
    effectiveCitationCount = Math.round(
      (data.effectiveCitationCount * 100) / totalCitationCount || 0,
    )
  }
  dataOverview = [
    { num: totalCitationCount, title: '总引用' },
    { num: effectiveCitationCount, title: '有效引用' },
    // eslint-disable-next-line no-use-before-define
    { num: parseFraction(data.recentCitationRatio), title: '≤7天源占比' },
  ]

  const nowCompanyInfo = enhancedReport.find(x => x.isPrimarySubject)
  if (nowCompanyInfo) {
    geoDiagnosis = nowCompanyInfo.geoDiagnosis
    nowCompanyInfo.brandImageTags.forEach(x => {
      brandImageTags.push({
        name: x.keyword,
        value: x.value,
      })
    })
    nowCompanyInfo.coreServicePerception.forEach(x => {
      const match = x.match(/^(.*?)[(（](\d+)[)）]$/)
      const [name, value] = match ? [match[1], match[2]] : [x, 0]
      brandAwareness.push({ name, value: Number(value) })
    })
    informationCompletenessSource = [
      { label: '基本资料', value: 0 },
      { label: '企业优势', value: 0 },
      { label: '产品服务', value: 0 },
      { label: '核心产品', value: 0 },
      { label: '信任背书', value: 0 },
      { label: '合作案例', value: 0 },
      { label: '产品详情', value: 0 },
      { label: '应用场景', value: 0 },
      { label: '推广区域', value: 0 },
    ]
    informationCompletenessSource.forEach(x => {
      // eslint-disable-next-line no-param-reassign
      x.value = nowCompanyInfo.informationCompletenessSource.includes(x.label) ? 100 : 0
    })
  }
  const mentionedTypeMap = {
    ordinary_information: { name: '普通消息', value: 0, color: '#4080FF' },
    commercial_consultation: { name: '商业消息', value: 0, color: '#FF5FA3' },
    cooperation_case: { name: '合作案例', value: 0, color: '#FFC45A' },
  }

  let mentionStrengthTotal = 0 // 提及强度总引用
  let coverageTotal = 0 // 覆盖率总引用
  let completionTotal = 0 // 完成度总引用
  let mentioningRateTotal = 0 // 首选被提及率总引用
  let qdMentionTotal = 0 // 强烈推荐总数
  let referenceLinkCountTotal = 0 // 引用链接数总引用
  enhancedReport.forEach(item => {
    const completionVal = parseFraction(item.informationCompletenessDetail)
    const coverageVal = Math.floor((item.tqMentionedByModels * 100) / item.mentionedByModelsCount)
    const mentioningRateVal = Math.floor((item.topMentionCount * 100) / item.mentionedByModelsCount)
    mentionStrengthTotal += Math.floor(
      ((item.qd_mention_count || 0) * 100) / item.mentionedByModelsCount,
    )
    qdMentionTotal += item.qd_mention_count ? item.mentioningRateVal : 0
    referenceLinkCountTotal += item.mentionedByModels?.length || 0

    completionTotal += completionVal
    completionArr.push({
      label: item.brandName,
      // eslint-disable-next-line no-use-before-define
      value: completionVal,
      isPrimarySubject: item.isPrimarySubject,
    })
    coverageTotal += coverageVal
    coverageArr.push({
      label: item.brandName,
      value: coverageVal,
      isPrimarySubject: item.isPrimarySubject,
    })
    mentioningRateTotal += mentioningRateVal
    mentioningRateArr.push({
      label: item.brandName,
      value: mentioningRateVal,
      isPrimarySubject: item.isPrimarySubject,
    })
    // 统计mentionedByModels中的contextType
    item.mentionedByModels.forEach(x => {
      if (mentionedTypeMap[x.contextType]) {
        mentionedTypeMap[x.contextType].value += 1
      } else {
        mentionedTypeMap[x.contextType] = { name: x.contextType, value: 1, color: '#FF4703' }
      }
    })
  })
  console.log('mentionedTypeMap', mentionedTypeMap)
  keywordRate = Object.values(mentionedTypeMap)
  if (nowCompanyInfo) {
    // 目标公司
    brandVisibility.push([
      {
        name: '覆盖率',
        value: Math.floor(
          (nowCompanyInfo.tqMentionedByModels * 100) / nowCompanyInfo.mentionedByModelsCount,
        ),
      },
      {
        name: '首选提及',
        value: Math.floor(
          (nowCompanyInfo.topMentionCount * 100) / nowCompanyInfo.mentionedByModelsCount,
        ),
      },
      {
        name: '首选推荐',
        value: nowCompanyInfo.qd_mention_count ? nowCompanyInfo.mentioningRateVal : 0,
      },
      {
        name: '信息完整度',
        value: parseFraction(nowCompanyInfo.informationCompletenessDetail),
      },
      {
        name: '提及强度',
        value: Math.floor(
          ((nowCompanyInfo.qd_mention_count || 0) * 100) / nowCompanyInfo.mentionedByModelsCount,
        ),
      },
      {
        name: '引用链接数',
        value: nowCompanyInfo.mentionedByModels?.length || 0,
      },
    ])
  } else {
    brandVisibility.push([
      { name: '覆盖率', value: 0 },
      { name: '首选提及', value: 0 },
      { name: '首选推荐', value: 0 },
      { name: '信息完整度', value: 0 },
      { name: '提及强度', value: 0 },
      { name: '引用链接数', value: 0 },
    ])
  }
  // 行业均值
  brandVisibility.push([
    { name: '覆盖率', value: Math.floor(coverageTotal / enhancedReport.length) },
    { name: '首选提及', value: Math.floor(mentioningRateTotal / enhancedReport.length) },
    { name: '首选推荐', value: Math.floor(qdMentionTotal / enhancedReport.length) },
    { name: '信息完整度', value: Math.floor(completionTotal / enhancedReport.length) },
    { name: '提及强度', value: Math.floor(mentionStrengthTotal / enhancedReport.length) },
    { name: '引用链接数', value: Math.floor(referenceLinkCountTotal / enhancedReport.length) },
  ])
  coverageArr = coverageArr.sort((a, b) => b.value - a.value)
  completionArr = completionArr.sort((a, b) => b.value - a.value)
  mentioningRateArr = mentioningRateArr.sort((a, b) => b.value - a.value)

  return {
    brandVisibility,
    brandImageTags,
    geoDiagnosis,
    brandAwareness,
    coverageArr,
    dataOverview,
    keywordRate,
    modelCitationDetail,
    completionArr,
    mentioningRateArr,
    informationCompletenessSource,
  }
}
